import { TogglePointFunctionHelper } from './toggle-point-function-helper';

/**
 * Method annotation factory that decides if the annotated method should be
 * defined or not. It can receive a flag or a string —the feature ID— and a
 * alternative to replace the experimental method.
 *
 * If a string is passed, the annotation function will look into the current
 * class for a property that matches the ID. This property should contain a
 * boolean that allows the function to decide if the experimental function
 * should be defined.
 *
 * @param featureIsOn Flag or ID to toggle between methods
 * @param alternativeMethod Method to use instead of the experimental
 */
export function aloneTogglePointFunction(featureIsOn: string | boolean, alternativeMethod: string) {
  return (target, _propertyKey: string, descriptor: PropertyDescriptor) => {
    const originalFunction = descriptor.value;
    descriptor.value = function evaluation(...args: any[]) {
      let executedFunction = originalFunction;
      if (isBoolean(featureIsOn)) {
        if (featureIsOn === true && isFunction(target[alternativeMethod])) {
          executedFunction = target[alternativeMethod];
        }
      } else if (asBoolean(this[featureIsOn as string]) && isFunction(target[alternativeMethod])) {
        executedFunction = target[alternativeMethod];
      }

      return executedFunction.apply(this, args);
    };
    return descriptor;
  };
}

/**
 * Method annotation factory that requires a feature name and the name of an
 * alternative method so when the component is created —and depending on the
 * toggle router— the experimental function can be defined or not.
 *
 * The annotation function will use the
 *
 * @param featureId Feature ID to be searched on the toggle router
 * @param alternativeMethod Name of the alternative method
 */
export function togglePointFunction(featureId: string, alternativeMethod: string) {
  return (target, _propertyKey: string, descriptor: PropertyDescriptor) => {
    const originalFunction = descriptor.value;
    descriptor.value = function evaluation(...args: any[]) {
      let executedFunction = originalFunction;
      if (TogglePointFunctionHelper.toggleRouterService?.isFeatureEnabled(featureId)) {
        executedFunction = target[alternativeMethod];
      }

      return executedFunction.apply(this, args);
    };
    return descriptor;
  };
}

/**
 * @ignore
 */
export function asBoolean(property: any): boolean {
  let result = false;
  if (isDefined(property) && isBoolean(property)) {
    result = property as boolean;
  }

  return result;
}

/**
 * @ignore
 */
export function isBoolean(property: any): boolean {
  return typeof property === 'boolean';
}

function isFunction(property: any): boolean {
  let result = false;
  if (isDefined(property) && typeof property === 'function') {
    result = true;
  } else {
    throw new Error('expected a function in feature function decorator');
  }

  return result;
}

function isDefined(property: any): boolean {
  let result = false;
  if (property !== null && property !== undefined) {
    result = true;
  } else {
    throw new Error('property is not defined or null on feature function decorator');
  }

  return result;
}

/**
 * @ignore
 */
export const nameOf = <T>(name: keyof T) => name;
